import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { AuthProvider } from '@/contexts/AuthContext';

/**
 * Application root layout
 * Sets up global context providers
 */
export function RootLayout() {
  return (
    <AuthProvider>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Outlet />
      </Box>
    </AuthProvider>
  );
}
